import pick from 'lodash/pick'
import * as ActionTypes from './actionTypes'

function makeAnalyticAction(type, metadataKeys = []) {
  return function(payload) {
    return {
      type: ActionTypes.ANALYTICS_TRACK,
      payload: {},
      meta: {
        analytics: {
          type,
          payload: pick(payload, ...metadataKeys),
        },
      },
    }
  }
}

export const trackNavigateToDoc = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'NAVIGATE_TO_NOTE',
    },
  },
})

export const trackNoteClicked = makeAnalyticAction('APP_NOTE_CLICKED', [
  'source',
])

export const trackMoveTo = makeAnalyticAction('APP_MOVE_TO', [
  'source',
  'depth',
  'distance',
])

export const trackNewNoteClicked = makeAnalyticAction('APP_NEW_NOTE_CLICKED', [
  'source',
  'depth',
])

export const trackNavigateToUpgrade = ({ incentiveId = null }) => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'NAVIGATE_TO_UPGRADE',
      payload: { incentiveId },
    },
  },
})

export const trackStepInUpgrade = ({ step = null, planSelected = null }) => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'STEP_IN_UPGRADE',
      payload: {
        step,
        planSelected,
      },
    },
  },
})

export const trackOpenQuickSwitch = ({ source }) => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: { source },
  meta: {
    analytics: {
      type: 'OPEN_QUICK_SWITCH',
    },
  },
})

export const trackNavigateFromSearch = ({ target, source }) => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'NAVIGATE_FROM_SEARCH',
      payload: {
        target,
        source,
      },
    },
  },
})

export const trackNavigateFromQuickSwitch = ({ target, source }) => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'NAVIGATE_FROM_QUICK_SWITCH',
      payload: {
        target,
        source,
      },
    },
  },
})

export const trackInviteSlackTeam = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'INVITE_SLACK_TEAM',
    },
  },
})

export const trackImportContact = provider => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'INVITE_MODAL_CLICK_IMPORT_CONTACT',
      payload: {
        provider,
      },
    },
  },
})

export const trackCopyInviteLink = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'COPY_INVITE_LINK',
    },
  },
})

export const trackOpenComments = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'OPEN_COMMENTS',
    },
  },
})

export const trackInterfaceShortcut = (shortcut = '') => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {
    shortcut,
  },
  meta: {
    analytics: {
      type: 'INTERFACE_SHORTCUT',
    },
  },
})

export const trackNavigateToActivity = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'NAVIGATE_TO_ACTIVITY',
    },
  },
})

export const trackNavigateToInsights = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'NAVIGATE_TO_INSIGHTS',
    },
  },
})

export const trackClickOnActivityItem = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'CLICK_ON_ACTIVITY_ITEM',
    },
  },
})

export const track = (type, payload = {}) => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type,
      payload,
    },
  },
})

export const trackPromotionalModalToSignup = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'PROMOTIONAL_MODAL_TO_SIGNUP',
    },
  },
})

export const trackPromotionalModalToLearnMore = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'PROMOTIONAL_MODAL_TO_LEARN_MORE',
    },
  },
})

export const trackDisableDirectNoteEdit = () => ({
  type: ActionTypes.ANALYTICS_TRACK,
  payload: {},
  meta: {
    analytics: {
      type: 'DISABLE_DIRECT_EDIT',
    },
  },
})
